const pluralizeFilter = ( value: number, singular: string, plural: string) => {
    const text = (value === 1) ? singular : plural;
    return value + ' ' + text;
  };

export default pluralizeFilter;
